import React, { useEffect, useRef, useState } from 'react';

const Trackbar = ({ initialValue, onUpdate, autoFocus }) => {
  const initialProgress = Math.round(((initialValue - 1) / (10 - 1)) * 100);
  const [value, setValue] = useState(initialValue);
  const [progressValue, setProgressValue] = useState(initialProgress);
  const inputRef = useRef(null);

  const handleInputChange = (e) => {
    const newValue = Number(e.target.value);
    setValue(newValue);

    const percentageValue = Math.round(((newValue - 1) / (10 - 1)) * 100);
    setProgressValue(percentageValue);

    inputRef.current.setAttribute('aria-valuenow', newValue);
  };

  useEffect(() => {
    onUpdate(value);
  }, [value]);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className="c-trackbar">
      <span className="c-trackbar__input-progress--track-bg" aria-hidden />
      <span
        className="c-trackbar__input-progress"
        style={{ width: `${progressValue}%` }}
        aria-hidden
      />
      <input
        ref={inputRef}
        type="range"
        min="1"
        max="10"
        step="1"
        value={value}
        aria-valuenow={value}
        onChange={handleInputChange}
        className="c-trackbar__input"
        aria-label={`Justerbart värde mellan 0 och 10`}
        aria-valuemin={1}
        aria-valuemax={10}
      />
      <div className="c-trackbar__scale-wrapper">
        {Array.from({ length: 10 }, (_, i) => (
          <span key={'scale_number' + i} className="c-trackbar__scale-item">
            {i + 1}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Trackbar;
